export enum FeatureName {
  VOUCHER = "VOUCHER",
  PREMIUM = "PREMIUM",
  REMUNERATION = "REMUNERATION"
}

export const FeatureNameEnumMapping: Record<FeatureName, string> = {
    [FeatureName.VOUCHER]: "VOUCHER",
    [FeatureName.PREMIUM]: "PREMIUM",
    [FeatureName.REMUNERATION]: "REMUNERATION"
  };

export interface FeatureNameInterface {
  id: FeatureName;
  value: string;
}
